const UPDATE_SUBMISSION_QUESTION = (state, payload) => {
  state.submissionItem.questionId = payload.value?.id;
  state.submissionItem.relatedContent = [];

  state.submissionItemDependencies.question = payload.value;
  state.referenceData.questions = payload.value ? [payload.value] : [];
};

export default UPDATE_SUBMISSION_QUESTION;
